<template>
    <v-select 
       :value="selected_notification" 
       v-bind:items="ares_notifications"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense" 
       :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    watch:{
        selected_notification: {            
            handler(){
                // this is needed when the selected notification is set from outside this component
                // the change-event will not fire so we watch the value and emit the change if needed
                this.$emit('updateData', {field: this.field, value: this.selected_notification===null ? 'ALL' : this.selected_notification});
            } 
        },
    },    
    props: {
        selected_notification: {
            type: String,
            default: 'ALL'
        },    
        ares_notifications: {
            type: Array,
            default: function() { return [
                {code: 'ALL', description: 'All'},
                {code: 'WRN', description: 'Warnings only'},
                {code: 'ERR', description: 'Errors only'}]; },
        },            
        label: String,
        field: {
            type: String,
            default: 'notification',
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        showInactive: {
            type: Boolean,
            default: false
        },
        isDense:{
            type: Boolean,
            default: true
        }
    },
    methods: {
        getAresLanguages() {
            return [
                {code: 'ALL', description: 'All'},
                {code: 'WRN', description: 'Warnings only'},
                {code: 'ERR', description: 'Errors only'}
            ];
        },
        updateData(v){
            // the prop must be updated. You cannot do it directly 
            // so you must update the parent field with an emit
            this.$emit('updateData', { "field": this.field, "value": v === null ? 'ALL' : v })
        }
    }
}

</script>